import { render, staticRenderFns } from "./FeePolicyGuide.vue?vue&type=template&id=1c02759a&"
import script from "./FeePolicyGuide.vue?vue&type=script&lang=ts&"
export * from "./FeePolicyGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports